module.exports = __webpack_public_path__ + "img/shopIcon4.f274c795.png";